import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { INSIGHTS_POLLING_INTERVAL_MS } from '@/utils/composables/useInsightsGeneration';
import { useInsightViewedTracking } from '@/utils/composables/useInsightViewedTracking';
import { useSwrPolling } from '@/utils/composables/useSwrPolling';
import { useInsightStatus, useTeamInfo } from '@/utils/swr';

/**
 * サイドバーとレールは同時にマウントされるので、
 * ルート遷移での再取得と生成中のポーリング（observe）はレールだけが行い、取得の重複を避ける。
 */
export const useInsightStatusBadge = (options: { observe?: boolean } = {}) => {
  const { data: teamInfo } = useTeamInfo();
  const enabled = computed(() => teamInfo.value?.enable_profile ?? false);
  const { data, mutate } = useInsightStatus(enabled);

  const processedUuid = computed(() =>
    data.value?.generation_status === 'processed' ? data.value.uuid : null,
  );
  const { isViewed } = useInsightViewedTracking(processedUuid);
  const hasUnviewedInsight = computed(
    () => processedUuid.value !== null && !isViewed.value,
  );

  if (options.observe) {
    const route = useRoute();
    watch(
      () => route.path,
      () => {
        if (enabled.value) void mutate();
      },
    );

    const isProcessing = computed(
      () => enabled.value && data.value?.generation_status === 'processing',
    );
    useSwrPolling(mutate, isProcessing, INSIGHTS_POLLING_INTERVAL_MS);
  }

  return { hasUnviewedInsight };
};
